// Danish (da)
export default {
  // --- Shell / nav ---
  app_name: 'Tidevand i nærheden',
  search_stations: 'Søg stationer',
  search_stations_hint: 'Søg stationer (⌘K)',
  settings: 'Indstillinger',
  app_store: 'Hent i App Store',
  google_play: 'Hent den på Google Play',
  app_promo_title: 'Download den gratis app. Den er hurtigere 🙂',
  app_promo_body: 'De samme tidevands- og strømforudsigelser, på din telefon.',
  privacy: 'Privatliv',
  terms: 'Vilkår',
  data_sources: 'Datakilder',
  support: 'Support',

  guides: 'Guider',
  // --- Home ---
  home_title: 'Find tidevand og strømme i nærheden',
  by_country: 'Efter land',
  favorite_tides: 'Favorit tidevande',
  recent_tides: 'Nylige tidevand',
  nearby_tides: 'Tidevand i nærheden',
  favorite_currents: 'Favorit strømme',
  recent_currents: 'Nylige strømme',
  nearby_currents: 'Strømme i nærheden',
  favorite_charts: 'Favorit søkort',
  recent_charts: 'Nylige søkort',
  nearby_charts: 'Søkort i nærheden',
  finding_stations: 'Finder stationer i nærheden af dig…',
  distance_away: '{{distance}} væk',

  // --- Search overlay ---
  search_placeholder: 'Søg stationer…',
  tide_stations: 'Tidevandsstationer',
  current_stations: 'Strømstationer',
  recents: 'Seneste',
  search_unavailable: 'Søgning er ikke tilgængelig lige nu.',
  no_stations_found: 'Ingen stationer fundet.',
  search_prompt: 'Søg tidevands- & strømstationer efter navn.',

  // --- Settings ---
  appearance: 'Udseende',
  appearance_system: 'System',
  appearance_light: 'Lys',
  appearance_dark: 'Mørk',
  tide_height: 'Tidevandshøjde',
  unit_feet: 'Fod',
  unit_meters: 'Meter',
  distance: 'Afstand',
  unit_miles: 'Mil',
  unit_kilometers: 'Kilometer',
  recent_stations: 'Nylige stationer',
  clear_recents: 'Ryd seneste',
  currents: 'Strømme',
  nautical_charts: 'Søkort',
  browse_by_country: 'Gennemse efter land',
  countries_auto: 'Automatisk',
  countries_always: 'Altid',
  countries_never: 'Aldrig',
  show: 'Vis',
  hide: 'Skjul',

  // --- Station pages (tide + current) ---
  tide_title: '{{name}} tidevand',
  current_title: '{{name}} strømme',
  last_tide: 'Sidste tidevand',
  next_tide: 'Næste tidevand',
  coefficient: 'Coef',
  last_current: 'Forrige strøm',
  next_current: 'Næste strøm',
  following_current: 'Følgende strøm',
  high: 'Høj',
  low: 'Lav',
  tides: 'Tidevand',
  sun: 'Sol',
  moon: 'Måne',
  sunrise_now: 'Solopgang',
  sunset_now: 'Solnedgang',
  moonrise_now: 'Månen står op',
  moonset_now: 'Månen går ned',
  sunrise_week: 'Opgang',
  sunset_week: 'Nedgang',
  moonrise_week: 'Opgang',
  moonset_week: 'Nedgang',
  add_to_favorites: 'Føj til favoritter',
  remove_from_favorites: 'Fjern fra favoritter',

  // --- Week table dates ---
  today: 'I dag',
  tomorrow: 'I morgen',

  // --- Moon phases ---
  phase_new_moon: 'Nymåne',
  phase_waxing_crescent: 'Tiltagende månesegl',
  phase_first_quarter: 'Første kvarter',
  phase_waxing_gibbous: 'Tiltagende måne',
  phase_full_moon: 'Fuldmåne',
  phase_waning_gibbous: 'Aftagende måne',
  phase_last_quarter: 'Sidste kvarter',
  phase_waning_crescent: 'Aftagende månesegl',

  // --- Tide / current status vocabulary ---
  rising: 'Stigende',
  falling: 'Faldende',
  high_tide: 'Højvande',
  low_tide: 'Lavvande',
  ebb: 'Ebbe',
  flood: 'Flod',
  slack: 'Stillestående vand',

  // --- Relative time (separate singular/plural keys, native-style) ---
  just_now: 'Lige nu',
  somethings_wrong: 'Der opstod en fejl',
  hour_ago: '{{hour}} time siden',
  hours_ago: '{{hour}} timer siden',
  minute_ago: '{{minute}} minut siden',
  minutes_ago: '{{minute}} minutter siden',
  hour_minute_ago: '{{hour}} time, {{minute}} minut siden',
  hour_minutes_ago: '{{hour}} time, {{minute}} minutter siden',
  hours_minute_ago: '{{hour}} timer, {{minute}} minut siden',
  hours_minutes_ago: '{{hour}} timer, {{minute}} minutter siden',
  hour_from_now: '{{hour}} time fra nu',
  hours_from_now: '{{hour}} timer fra nu',
  minute_from_now: '{{minute}} minut fra nu',
  minutes_from_now: '{{minute}} minutter fra nu',
  hour_minute_from_now: '{{hour}} time, {{minute}} minut fra nu',
  hour_minutes_from_now: '{{hour}} time, {{minute}} minutter fra nu',
  hours_minute_from_now: '{{hour}} timer, {{minute}} minut fra nu',
  hours_minutes_from_now: '{{hour}} timer, {{minute}} minutter fra nu',

  // --- Insights ---
  insights_7_day_overview: '7-dages indsigt',
  no_insights_available: 'Ingen indsigter tilgængelige for denne station.',
  insights_current_extremes: 'Strømekstremer',
  insights_fastest_flood: 'Hurtigste flod',
  insights_fastest_ebb: 'Hurtigste ebbe',
  insights_strongest_daily_currents: 'Daglige topstrømme',
  insights_fastest_current: 'Hurtigste',
  insights_slowest_current: 'Langsomste',
  insights_tidal_extremes: 'Tidevandsekstremer',
  insights_highest_tide: 'Højeste tidevand',
  insights_lowest_tide: 'Laveste tidevand',
  insights_strongest_daily_movements: 'Største tidevandsintervaller',
  insights_largest_tide: 'Størst',
  insights_smallest_tide: 'Mindst',
  insights_value_at_time: '{{value}} kl. {{time}}',
  insights_tidal_range_label: 'tidevandsinterval',
  insights_max_current_label: 'maks strøm',

  // --- Insight bands ---
  band_smaller_than_usual: 'Mindre end normalt',
  band_typical: 'Typisk',
  band_larger_than_usual: 'Større end normalt',
  band_unusually_large: 'Usædvanligt stort',
  band_lower_than_usual: 'Lavere end normalt',
  band_unusually_low: 'Usædvanligt lavt',
  band_slower_than_usual: 'Langsommere end normalt',
  band_faster_than_usual: 'Hurtigere end normalt',
  band_unusually_fast: 'Usædvanligt hurtigt',
  band_smaller_than_usual_height: 'Lavere end normalt',
  band_larger_than_usual_height: 'Højere end normalt',
  band_unusually_large_height: 'Usædvanligt højt',

  // --- Map attribution ---
  attribution: 'Kildeangivelse',
  attribution_osm: 'Kortdata © OpenStreetMap-bidragsydere',
  attribution_tiles: 'Kortfliser af OpenFreeMap',
  attribution_style: 'Kortstil © OpenMapTiles',
  ok: 'OK',

  // --- Explore map ---
  current_speed: 'Strømhastighed',
  depth: 'Dybde',
  speed: 'Fart',
  depth_datum: 'Dybder fra',
  depth_drying: 'Tørlægges',
  depth_loading: 'Indlæser dybdedata…',
  depth_datum_tag: 'Dybder i {{unit}} under {{datum}}',
  depth_not_for_navigation: 'Ikke til navigation.',
  depth_unavailable: 'Dybdedata er ikke tilgængelige lige nu.',
  depth_unit_m: 'm',
  depth_unit_ft: 'ft',
  go_mode_start: 'GO',
  go_mode_start_label: 'Start Go-tilstand',
  go_mode_exit: 'Afslut Go-tilstand',
  go_mode_location_denied: 'Go-tilstand kræver din placering. Aktivér den via låsikonet.',
  go_mode_location_denied_ok: 'OK',
  radar: 'Radar',
  radar_precipitation: 'Nedbør',
  radar_light: 'let',
  radar_moderate: 'moderat',
  radar_heavy: 'kraftig',
  radar_storm: 'voldsom',
  radar_forecast: 'prognose',
  radar_none_for_time: 'ingen radar for dette tidspunkt',
  now: 'Nu',
  explore_prompt_denied:
    'Placering er slået fra for dette websted - aktivér den via låsikonet i adresselinjen.',
  open_full_map: 'Åbn hele kortet',
  close_full_map: 'Luk hele kortet',
  explore_full_map: 'Udforsk hele kortet',
  center_on_location: 'Centrer på min placering',
  show_my_location: 'Vis min placering',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: 'regioner',
  no_stations_found_location: 'Ingen stationer fundet.',
  tides_and_currents_by_country: 'Tidevand & strømme efter land',

  // --- SEO titles / descriptions ---
  settings_seo_description: 'Vælg dine enheder for tidevandshøjder og afstande.',
  tide_seo_description: 'Tidevandsforudsigelser, høj- og lavvandstider for {{name}}{{location}}.',
  current_seo_description:
    'Forudsigelser af tidevandsstrømme, flod- og ebbetider for {{name}}{{location}}.',
  location_title: '{{name}} tidevand & strømme',
  country_seo_description:
    'Tidevandstider og forudsigelser af tidevandsstrømme for {{name}}. Gennemse {{stateTerm}} og kysttidevandsstationer i {{name}}.',
  state_seo_description:
    'Tidevands- og strømforudsigelser for {{name}}, {{country}}. Høj- og lavvandstider for kyststationer i {{name}}.',
  city_seo_description:
    'Tidevandstider og forudsigelser af tidevandsstrømme for {{place}}. Høj- og lavvande og strømme i nærheden af {{name}}.',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: 'Søkort for {{name}}',
  chart_intro:
    'Gratis søkort over {{title}}: kortlagte vanddybder, bøjer, båker, skær, vrag, lystbådehavne, ankerpladser og tidevandsstationer.',
  chart_page_name: '{{title}} søkort',
  chart_seo_description:
    'Gratis søkort over {{title}}: kortlagte vanddybder, bøjer, båker, skær, vrag, lystbådehavne, ankerpladser og tidevandsstationer.',

  countries_seo_title: 'Tidevands- & strømstationer efter land',
  countries_seo_description:
    'Gennemse tidevands- og strømstationer efter land. Høj- og lavvandstider og forudsigelser af tidevandsstrømme for kystområder over hele verden.',
  home_seo_description:
    'Find tidevandstider og forudsigelser af tidevandsstrømme for kyststationer i nærheden. Se høj- og lavvand for din placering, eller gennemse stationer efter land.',
  explore_play: 'Afspil',
  explore_pause: 'Pause',
  explore_playback_speed: 'Afspilningshastighed',
  explore_time: 'Tid',
  skip_to_content: 'Spring til hovedindhold',
  // --- Weather (station pages) ---
  weather: 'Marint vejr',
  wind: 'Vind',
  gusts: 'Vindstød',
  seas: 'Bølger',
  time: 'Tid',
  air_temp: 'Luft',
  water_temp: 'Vand',
  water_temperature: 'Vandtemperatur',
  humidity: 'Luftfugtighed',
  pressure: 'Lufttryk',
  precip_chance: 'Nedbør',
  chances: 'Sandsynlighed',
  precip_rate: 'Nedbørsintensitet',
  visibility: 'Sigtbarhed',
  condition_thunderstorms: 'Tordenvejr',
  condition_freezing_rain: 'Isslag',
  condition_sleet: 'Slud',
  condition_snow: 'Sne',
  condition_fog: 'Tåge',
  condition_rain: 'Regn',
  condition_cloudy: 'Skyet',
  condition_partly_cloudy: 'Delvist skyet',
  condition_clear: 'Klart',
  weather_thunder: 'Torden',
  note_seas_computed_from_wind: 'Bølgehøjder er beregnet ud fra vind og kystlinje.',
  note_seas_from_nearby_open_water: 'Bølgedata stammer fra nærliggende åbent farvand.',
  note_seas_open_water_nearby:
    'Bølgerne på det åbne vand i nærheden er omkring {{height}}. Her kan det være roligere.',
  note_seas_open_water_distant:
    'Bølgerne på åbent vand {{distance}} væk er omkring {{height}}. Her kan det være roligere.',
  note_seas_open_water_distant_dir:
    'Bølgerne på åbent vand {{distance}} {{direction}} herfra er omkring {{height}}. Her kan det være roligere.',
  note_seas_unavailable: 'Der findes ingen pålidelige bølgedata for dette punkt.',
  note_sheltered_water_sees_less:
    'I beskyttet farvand er bølgerne som regel mindre end disse værdier for åbent farvand.',
  note_no_warning_feed_coverage: 'Ingen officiel farvandsvarsling dækker dette punkt.',
  note_nearest_point_across_land: 'Det nærmeste prognosepunkt ligger på den anden side af land.',
  warnings_none_active: 'Ingen farvandsvarsler i kraft',
  warnings_unavailable: 'Farvandsvarsler er ikke tilgængelige for denne placering',
  warning_show_text: 'Vis officiel tekst',
  warning_hide_text: 'Skjul officiel tekst',
  weather_updated: 'Opdateret {{time}}',
  current_conditions: 'Aktuelle forhold',
  daily_forecast: 'Daglig prognose',
  expand_for_hourly: 'Udvid for timeprognose',
  hourly: 'Timevis',
  hourly_forecast: 'Timeprognose',
  wind_speed: 'Vindhastighed',
  wind_gusts: 'Vind og vindstød',
  pressure_humidity: 'Lufttryk og luftfugtighed',
  max_seas: 'Maks. bølger',
  visibility_excellent: 'Fremragende',
  visibility_good: 'God',
  visibility_moderate: 'Moderat',
  visibility_poor: 'Dårlig',
  forecaster_text_link: 'Varselstekst fra {{issuer}}',
  temperature: 'Temperatur',
  unit_fahrenheit: 'Fahrenheit',
  unit_celsius: 'Celsius',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}} – {{end}}',
  warning_window_open: '{{start}}+',
  range_separator_short: '-',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: 'med',
  wave_period_short: '{{period}}s',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: 'N',
  compass_NNE: 'NNØ',
  compass_NE: 'NØ',
  compass_ENE: 'ØNØ',
  compass_E: 'Ø',
  compass_ESE: 'ØSØ',
  compass_SE: 'SØ',
  compass_SSE: 'SSØ',
  compass_S: 'S',
  compass_SSW: 'SSV',
  compass_SW: 'SV',
  compass_WSW: 'VSV',
  compass_W: 'V',
  compass_WNW: 'VNV',
  compass_NW: 'NV',
  compass_NNW: 'NNV',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: 'Varsel for småbåde',
  warning_type_gale_warning: 'Kulingvarsel',
  warning_type_gale_watch: 'Mulig kuling',
  warning_type_storm_warning: 'Stormvarsel',
  warning_type_storm_watch: 'Mulig storm',
  warning_type_hurricane_force_wind_warning: 'Orkanvarsel',
  warning_type_hurricane_force_wind_watch: 'Mulig orkan',
  warning_type_special_marine_warning: 'Særligt farvandsvarsel',
  warning_type_marine_weather_statement: 'Farvandsmelding',
  warning_type_hazardous_seas_warning: 'Varsel om farlig sø',
  warning_type_brisk_wind_advisory: 'Varsel om frisk vind',
  warning_type_low_water_advisory: 'Varsel om lav vandstand',
  warning_type_dense_fog_advisory: 'Varsel om tæt tåge',
  warning_type_heavy_freezing_spray_warning: 'Varsel om kraftig overisning',
  warning_type_strong_wind_warning: 'Varsel om hård vind',
  warning_type_gale_force_wind_warning: 'Kulingvarsel',
  warning_type_storm_force_wind_warning: 'Stormvarsel',
  warning_type_wind_warning: 'Vindvarsel',
  warning_type_dense_fog_warning: 'Varsel om tæt tåge',
  warning_type_icing_warning: 'Overisningsvarsel',
  warning_type_typhoon_warning: 'Tyfonvarsel',
  warning_type_wind_wave_warning: 'Varsel om høje bølger',
  warning_type_wind_wave_advisory: 'Bølgevarsel',
  warning_type_strong_wind_advisory: 'Varsel om hård vind',
  warning_type_storm_surge_warning: 'Stormflodsvarsel',
  warning_type_storm_surge_advisory: 'Varsel om stormflod',
  warning_type_thunderstorm_warning: 'Tordenvejrsvarsel',
  warning_type_rough_sea_warning: 'Varsel om grov sø',
  warning_type_fog_warning: 'Tågevarsel',
  sea_state_calm_rippled: 'Krusninger',
  sea_state_smooth: 'Rolig sø',
  sea_state_slight: 'Let sø',
  sea_state_moderate: 'Jævn sø',
  sea_state_rough: 'Ru sø',
  sea_state_very_rough: 'Meget ru sø',
  sea_state_high: 'Høj sø',
  sea_state_very_high: 'Meget høj sø',
  sea_state_phenomenal: 'Ekstrem sø',
  hazard_showers: 'Byger',
  hazard_reduced_visibility: 'Nedsat sigtbarhed',
  hazard_haze: 'Dis',
  hazard_waterspout: 'Skypumper',
  hazard_freezing_spray: 'Isslag fra søsprøjt',
  hazard_ice: 'Is',
  marine_summary_sea_wind: '{{sea}}, {{direction}}-vind på {{speed}}.',
  marine_summary_wind_only_gusting: '{{direction}}-vind på {{speed}}, vindstød {{gust}}.',
  marine_summary_sea_wind_gusting: '{{sea}}, {{direction}}-vind på {{speed}}, vindstød {{gust}}.',
  marine_summary_wind_only: '{{direction}}-vind på {{speed}}.',
  marine_summary_sea_only: '{{sea}}.',
  marine_prediction_caveat_tide_one:
    'Tidevandsforudsigelser er astronomiske, så vejret i den varsling kan hæve eller sænke den faktiske vandstand.',
  marine_prediction_caveat_tide_many:
    'Tidevandsforudsigelser er astronomiske, så vejret i de varslinger kan hæve eller sænke den faktiske vandstand.',
  marine_prediction_caveat_current_one:
    'Strømforudsigelser er astronomiske, så vejret i den varsling kan forstærke eller svække den faktiske strøm.',
  marine_prediction_caveat_current_many:
    'Strømforudsigelser er astronomiske, så vejret i de varslinger kan forstærke eller svække den faktiske strøm.',
  marine_warning_active: 'Der er udsendt en farvandsudsigt-advarsel for dette område.',
  marine_warnings_active: 'Der er udsendt advarsler for dette område.',
  marine_warning_upcoming: 'Der er udsendt en advarsel for dette område, som gælder fra {{time}}.',
  marine_warnings_upcoming: 'Der er udsendt advarsler for dette område, som gælder fra {{time}}.',
  marine_summary_hazard_now: 'Lige nu: {{hazard}}.',
  marine_summary_hazard_later: 'I prognosen: {{hazard}}.',
  marine_tide_rising: 'Vandstanden er {{height}} og stiger: næste højvande {{next}} kl. {{time}}.',
  marine_tide_falling: 'Vandstanden er {{height}} og falder: næste lavvande {{next}} kl. {{time}}.',
  marine_current_flood: 'Næste indgående strøm {{speed}} kl. {{time}}.',
  marine_current_ebb: 'Næste udgående strøm {{speed}} kl. {{time}}.',
  marine_current_slack: 'Næste stillestående vand kl. {{time}}.',
  marine_current_now_flood: 'Strømmen går ind med {{speed}}.',
  marine_current_now_ebb: 'Strømmen går ud med {{speed}}.',
  marine_current_now_slack: 'Strømstille.',
  marine_current_peak: 'Maksimum {{speed}} kl. {{time}}.',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: 'Fyr',
  furn_buoy: 'Bøje',
  furn_beacon: 'Båke',
  furn_wreck: 'Vrag',
  furn_rock: 'Skær',
  furn_obstruction: 'Hindring',
  furn_anchorage: 'Ankerplads',
  furn_tss: 'Trafiksepareringssystem',
  furn_routing: 'Ruteføring',
  furn_title_buoy: '{{category}} bøje',
  furn_title_beacon: '{{category}} båke',
  furn_cat_port: 'Bagbords',
  furn_cat_starboard: 'Styrbords',
  furn_cat_preferred_channel_port: 'Anbefalt løb bagbord',
  furn_cat_preferred_channel_starboard: 'Anbefalt løb styrbord',
  furn_cat_safe_water: 'Midtfarvands',
  furn_cat_isolated_danger: 'Isoleret fare',
  furn_cat_north: 'Nord',
  furn_cat_east: 'Øst',
  furn_cat_south: 'Syd',
  furn_cat_west: 'Vest',
  furn_cat_special: 'Special',
  furn_cat_mooring: 'Fortøjnings',
  furn_cat_lateral: 'Sideafmærkning',
  furn_characteristic: 'Karakter',
  furn_range: 'Lysvidde',
  furn_height: 'Højde',
  furn_colour: 'Farve',
  furn_shape: 'Form',
  furn_lights_on_mark: 'Lys på denne afmærkning',
  furn_topmark: 'Topbetegnelse',
  furn_class: 'Klasse',
  furn_least_depth_over: 'Mindste dybde over',
  furn_depth_over: 'Dybde over',
  furn_state: 'Tilstand',
  furn_type: 'Type',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: 'Søkabel',
  furn_pipeline: 'Rørledning',
  furn_restricted_area: 'Restriktionsområde',
  furn_restriction: 'Restriktion',
  furn_mpa: 'Marint beskyttet område',
  furn_protection: 'Beskyttelse',
  furn_agency: 'Forvaltes af',
  furn_mpa_note: 'En bevaringsudpegning, ikke en sejladsbegrænsning.',
  furn_sector: 'Sektor',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: 'Fast {{colour}} lys.',
  lightw_fl: 'Blinker {{colour}} hvert {{period}}. sekund.',
  lightw_fl_group: 'Blinker {{colour}} i grupper på {{count}}, hvert {{period}}. sekund.',
  lightw_lfl: 'Et langt {{colour}} blink hvert {{period}}. sekund.',
  lightw_q: 'Hurtige {{colour}} blink.',
  lightw_iso: 'Lige lang {{colour}} lys og mørke, hvert {{period}}. sekund.',
  lightw_oc: 'Fast {{colour}} lys med kort formørkelse hvert {{period}}. sekund.',
  lightcolour_white: 'hvidt',
  lightcolour_red: 'rødt',
  lightcolour_green: 'grønt',
  lightcolour_yellow: 'gult',
  furn_feet_charted_value: '{{feet}} ft ({{metres}} m i søkortet)',
  furn_light_yes: 'ja',
  furn_shown_neutral: '{{colours}} (vist neutralt)',
  furn_note_light: 'Sådan ser fyret ud om natten; det er sådan, søfarende genkender det.',
  furn_note_lateral_b_port:
    'Markerer VENSTRE side af sejlrenden på vej ind fra havet (IALA B: grøn stumpbøje).',
  furn_note_lateral_b_starboard:
    'Markerer HØJRE side af sejlrenden på vej ind fra havet (IALA B: “rødt til højre på vej ind”).',
  furn_note_lateral_a_port:
    'Markerer BAGBORDS side af sejlrenden på vej ind fra havet (IALA A: rødt til bagbord).',
  furn_note_lateral_a_starboard:
    'Markerer STYRBORDS side af sejlrenden på vej ind fra havet (IALA A: grønt til styrbord).',
  furn_note_safe_water:
    'Frit farvand hele vejen rundt, typisk anduvnings- eller midtfarvandsafmærkning.',
  furn_note_isolated_danger: 'Udlagt over en isoleret fare med sejlbart vand hele vejen rundt.',
  furn_note_cardinal_north: 'Kompasafmærkning: passér NORD om den.',
  furn_note_cardinal_east: 'Kompasafmærkning: passér ØST om den.',
  furn_note_cardinal_south: 'Kompasafmærkning: passér SYD om den.',
  furn_note_cardinal_west: 'Kompasafmærkning: passér VEST om den.',
  furn_note_special: 'Specialafmærkning (gul): grænser, kabler, fortøjninger, kapsejlads.',
  furn_note_preferred_starboard: 'Skillemærke: den foretrukne sejlrende ligger om styrbord.',
  furn_note_preferred_port: 'Skillemærke: den foretrukne sejlrende ligger om bagbord.',
  furn_note_mooring: 'Fortøjningsbøje.',
  furn_vessel: 'Skib',
  furn_depth_quality: 'Dybdekvalitet',
  furn_length: 'Længde',
  furn_position_accuracy: 'Positionsnøjagtighed',
  furn_remarks: 'Bemærkninger',
  furn_circumstances: 'Omstændigheder',
  furn_status: 'Status',
  furn_note_shom: 'Kortlagt af Shom (Frankrig). ©Shom, CC BY-SA 4.0.',
  furn_lock: 'Sluse',
  furn_bridge: 'Bro',
  furn_overhead_cable: 'Luftledning',
  furn_notice_mark: 'Varselsmærke',
  furn_distance_mark: 'Afstandsmærke',
  furn_daymark: 'Dagmærke',
  furn_channel: 'Sejlrende',
  furn_vertical_clearance_closed: 'Frihøjde (lukket)',
  furn_vertical_clearance_open: 'Frihøjde (åben)',
  furn_datum: 'Referenceniveau',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    'Indlands-ENC (US Army Corps of Engineers). Frihøjder måles over det angivne referenceniveau; ved højvande i floden er den reelle frihøjde mindre.',
  furn_note_wreck: 'Kortlagt vrag. Dybder er kortværdier, ikke verificerede.',
  furn_note_anchorage: 'Kortlagt ankerplads.',
  furn_note_tss: 'Ensrettede sejlruter. Mindre fartøjer krydser vinkelret og holder klar.',
  furn_route: 'Rute',
  furn_fairway: 'Sejlløb',
  furn_recommended_track: 'Anbefalet rute',
  furn_navigation_line: 'Navigationslinje',
  furn_leading_line: 'Ledelinje',
  furn_clearing_line: 'Friholdelseslinje',
  furn_transit_line: 'Transitlinje',
  furn_traffic: 'Trafik',
  furn_orientation: 'Orientering',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway: 'Kortlagt sejlløb: den vedligeholdte eller foretrukne rende.',
  furn_note_track: 'Kortlagt kurslinje.',
  furn_note_track_fixed_marks: 'Kortlagt kurslinje, baseret på faste sømærker (overet).',
  furn_note_leading_line: 'Hold ledemærkerne overet for at blive på den kortlagte linje.',
  furn_note_navigation_line: 'Kortlagt navigationslinje.',
  furn_poi_marina: 'Lystbådehavn',
  furn_poi_fuel: 'Brændstof',
  furn_poi_slipway: 'Bådrampe',
  furn_poi_ferry_terminal: 'Færgeterminal',
  furn_poi_boatyard: 'Bådeværft',
  furn_poi_lighthouse: 'Fyrtårn',
  furn_note_slipway: 'Bådrampe.',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: 'Følg min retning',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: ingen data her',
  ww_row_no_forecast_after: '{{row}}: ingen prognose efter {{when}}',
  ww_row_no_forecast: '{{row}}: ingen prognose så langt frem',
  ww_unavailable: 'Vejrdata er ikke tilgængelige',
  explore_show_player: 'Vis tidslinjen',
  explore_hide_player: 'Skjul tidslinjen',

  // --- Ruteplanlægning på /explore ---
  // Beskriv, rådgiv aldrig; aldrig "sikker". Tjenestens ansvarsfraskrivelse
  // vises ordret fra svaret; route_disclaimer er kun reserven.
  route_plan: 'Planlæg en rute',
  route_leave: 'Forlad ruteplanlægning',
  route_title: 'Rute',
  route_prompt_start: 'Tryk på vandet, hvor du starter.',
  route_prompt_start_desktop:
    'Klik på vandet, hvor du starter, og klik derefter på din destination.',
  route_prompt_end: 'Start sat. Tryk nu på din destination.',
  route_prompt_end_desktop: 'Start sat. Klik nu på din destination.',
  route_drag_hint: 'Nålene kan trækkes.',
  route_clear: 'Ryd',
  route_swap: 'Byt start og destination',
  route_share: 'Kopiér link',
  route_copied: 'Link kopieret',
  route_start: 'Start',
  route_destination: 'Destination',
  route_near: 'ved {{name}}',
  route_loading: 'Ruten beregnes…',
  route_loading_sub: 'Som regel et par sekunder. Nogle områder tager op til 30 sekunder.',
  route_loading_slow: 'Arbejder stadig…',
  route_loading_slow_sub: 'Dette område tager længere tid end normalt.',
  route_summary_time: '{{duration}} ved {{speed}}',
  route_planning_speed: 'Planlægningsfart',
  route_shoalest: 'Laveste sted på ruten',
  route_planning_draft: 'planlægningsdybgang',
  route_change: 'skift',
  route_draft_title: 'Planlægningsdybgang',
  route_draft_help:
    'Den dybde, ruten planlægges til, ikke din båds dybgang. Dybere finder færre veje, lavere finder flere.',
  route_datum: 'Dybder ved kortnul (MLLW), uden tidevand.',
  route_unassured_note:
    'Orange strækninger krydser vand, som søkort og opmåling ikke opløser under {{draft}}.',
  route_row_start: 'Start {{label}}',
  route_row_heading: 'styr {{course}}° ({{point}})',
  route_row_end: 'Ankomst {{label}}',
  route_row_end_sub: 'rutens slutning',
  route_turn_left: 'Drej til venstre til {{course}}°',
  route_turn_right: 'Drej til højre til {{course}}°',
  route_bear_left: 'Hold til venstre til {{course}}°',
  route_bear_right: 'Hold til højre til {{course}}°',
  route_then: '{{first}}, derefter {{second}}',
  route_keep_mark: 'Hold {{mark}} på din {{hand}}',
  route_leave_channel: 'Forlad sejlrenden ved {{mark}}',
  route_on_your: 'på din {{hand}} ({{side}})',
  route_hand_left: 'venstre side',
  route_hand_right: 'højre side',
  route_side_port: 'bagbord',
  route_side_starboard: 'styrbord',
  route_mark_buoy: '{{color}} bøje {{num}}',
  route_mark_light: '{{color}}t fyr {{num}}',
  route_mark_daybeacon: '{{color}} båke {{num}}',
  route_mark_lighted: '{{mark}} (med lys)',
  route_red: 'rød',
  route_green: 'grøn',
  route_follow: 'Følg {{name}}',
  route_follow_two: 'Følg {{first}}, derefter {{second}}',
  route_follow_channel: 'sejlrenden {{name}}',
  route_follow_named: '{{name}}',
  route_follow_unnamed: 'den afmærkede sejlrende',
  route_follow_marks: '{{count}} afmærkninger',
  route_greens_on: 'grønne på din {{hand}}',
  route_reds_on: 'røde på din {{hand}}',
  route_show_marks: 'Vis afmærkninger',
  route_hide_marks: 'Skjul afmærkninger',
  route_why: 'Hvorfor drejer den her?',
  route_turn_reason: 'Drejer her, fordi {{reason}}',
  route_lights: 'Fyr inden for rækkevidde: {{lights}}',
  route_stretch_unassured: 'dybde under {{draft}} ikke opløst',
  route_stretch_rocky: 'mellem kortlagte sten',
  route_stretch_canal: 'kanal: slusedrift, porte og frihøjde under broer ikke modelleret',
  route_step_of: 'Trin {{n}} af {{total}}',
  route_all_steps: 'Alle trin',
  route_prev_step: 'Forrige trin',
  route_next_step: 'Næste trin',
  route_minutes: '{{n}} min',
  route_hours: '{{h}} t',
  route_hours_minutes: '{{h}} t {{m}} min',
  route_err_on_land_origin: 'Din start ligger på kortlagt land',
  route_err_on_land_destination: 'Din destination ligger på kortlagt land',
  route_err_on_land_origin_sub:
    'Træk startnålen ud i vandet. Et marskområde, en strand eller en mole tæller som land på søkortet.',
  route_err_on_land_destination_sub:
    'Træk destinationsnålen ud i vandet. Et marskområde, en strand eller en mole tæller som land på søkortet.',
  route_err_no_route: 'Ingen rute ved en planlægningsdybgang på {{draft}}',
  route_err_no_route_sub:
    'Et sted mellem de to punkter er søkortet lavere end {{draft}}. En mindre planlægningsdybgang finder måske en vej.',
  route_err_no_snap: 'Intet kortlagt vand nær et af punkterne',
  route_err_no_snap_sub: 'Flyt nålene tættere på åbent vand.',
  route_err_outside: 'Ruteplanlægning dækker indtil videre amerikanske farvande',
  route_err_outside_sub:
    'Ruter bygges ud fra NOAA-søkort, så begge punkter skal ligge i amerikanske farvande. Flere kyster senere.',
  route_err_timeout: 'Rutetjenesten var for længe om det',
  route_err_timeout_sub: 'Nogle områder tager op til 30 sekunder, og her løb tiden ud.',
  route_err_unavailable: 'Ruteplanlægning er ikke tilgængelig lige nu',
  route_err_unavailable_sub: 'Prøv igen om et øjeblik.',
  route_err_busy: 'For mange ruteforespørgsler',
  route_err_busy_sub: 'Vent et minut, og prøv igen.',
  route_try_again: 'Prøv igen',
  route_disclaimer:
    'Ikke til navigation. Denne rute følger den afmærkede sejlrende som angivet på søkortet; den er ikke en påstand om, at vandet er sikkert.',
  route_promo_title: 'Følg denne rute i appen med Go-tilstand',
  route_promo_body:
    'Go-tilstand holder din båd på søkortet med afstanden til næste afmærkning eller drej, dybden under dig og den nærmeste stations tidevand og strøm. I Tides Near Me til iPhone og Android, med abonnement.',
}
